// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"976e0dd9","412":"f35a87d0","678":"8bcec97b"}[chunkId] + ".chunk.js";
};